import {
    MDBAlert,
    MDBBtn,
    MDBCheckbox,
    MDBDatatable,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBSelect,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBTooltip,
} from 'mdb-react-ui-kit';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../../components/body/BodyPage";


import MainLinks from "../../../components/navlinks/MainLinks";
import TrustedIPAddressRange from './TrustedIPAddressRange';
import DeviceToTrustUsers from './DeviceToTrustUsers';
import TrustedDevice from './TrustedDevice';
import PendingUserDevice from './PendingUserDevice';
import AuthorizedUserDevice from './AuthorizedUserDevice';
import BlockedUser from './BlockedUser';
import { useLocation, useNavigate } from 'react-router';
import { getAllSecurityDesktopInfo } from '../../../apiclients/streamsapi_bridge';
function SecurityRegistration() {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const actTab = location.state ? location.state.tab ? location.state.tab : "tab1" : "tab1";
    const [basicActive, setBasicActive] = useState(actTab);

    const [status2, setStatus2] = useState('Pending');
    const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");
    const [isloading, setIsloading] = useState(true);
    const [trustedIPS, settrustedIPS] = useState([]);
    const [pendingUsers, setpendingUsers] = useState([]);
    const [authorixedUser, setauthorixedUser] = useState([]);
    const [blockedUsers, setblockedUsers] = useState([]);
    const [devicesToTrust, setdevicesToTrust] = useState([]);
    const [trustedDevices, settrustedDevices] = useState([]);


    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };


    async function fetchData() {
        const response = await getAllSecurityDesktopInfo(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + JSON.stringify(rawData));
        // setAssignedNumbers(rawData?.ph_numbers?.assigned_phnum ?? []);
       
        settrustedIPS(rawData?.ip_Details ?? []);
        setpendingUsers(rawData?.pending_Users ?? []);
        setauthorixedUser(rawData?.authorized_Users ?? []);
        setblockedUsers(rawData?.blocked_Users?? []);
        setdevicesToTrust(rawData?.devices_to_Trust ?? []);
        settrustedDevices(rawData?.trusted_Devices ?? []);

    }


    useEffect(() => {
        fetchData();
    }, []);










    useEffect(() => {
        if (updatesuccessMessage) {
            setTimeout(() => {
                setUpdateSuccessMessage("");
            }, 5000);
        }
    }, [updatesuccessMessage]);

    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={130}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t('Security Manager')}
                                        </h5>
                                    </div>
                                    <div>

                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    Trusted IP Address Range
                                                </MDBTabsLink>
                                            </MDBTabsItem>


                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    Select the Device(s) to Trust for ALL Users
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                                    Trusted Device(s)
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
                                                    Pending User(s) on Device(s)
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab5')} active={basicActive === 'tab5'}>
                                                    Authorized User(s) on Device(s)
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab6')} active={basicActive === 'tab6'}>
                                                    Blocked User(s)
                                                </MDBTabsLink>
                                            </MDBTabsItem>



                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                <TrustedIPAddressRange
                                                trustedIPS = {trustedIPS}
                                                />
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                <DeviceToTrustUsers
                                                devicesToTrust = {devicesToTrust} />
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === "tab3"}>
                                                <TrustedDevice 
                                                trustedDevices = {trustedDevices}
                                                />
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === "tab4"}>
                                                <PendingUserDevice 
                                                pendingUsers = {pendingUsers}
                                                />
                                            </MDBTabsPane>


                                            <MDBTabsPane open={basicActive === "tab5"}>
                                                <AuthorizedUserDevice 
                                                authorixedUser = {authorixedUser}
                                                />
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === "tab6"}>
                                                <BlockedUser 
                                                blockedUsers = {blockedUsers}
                                                />
                                            </MDBTabsPane>


                                        </MDBTabsContent>

                                    </div>
                                </div>
                            </section>
                            {isloading && (
                                <>
                                    <div className="loadingclass">
                                        <MDBBtn disabled>
                                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                            Loading...
                                        </MDBBtn>
                                    </div>
                                </>
                            )}

                        </>
                    }
                />


            </>
        </React.Fragment >
    )
}
export default SecurityRegistration